module.exports = __webpack_public_path__ + "static/media/Rosewood Drive, San Francisco, CA3.04d1246a.jpg";